import DataTable from "datatables.net-react";
import DT from "datatables.net-dt";
import "datatables.net-responsive-dt";
import "datatables.net-select-dt";
import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { getAllMaintenanceTypes, deleteMaintenanceType } from "../../../redux/MaintenanceTypeSlice/MaintenanceTypeSlice";
import Logo from "../../../Images/logo192.png";

DataTable.use(DT);

export default function MaintenanceTypes() {
  const [maintenanceType, setMaintenanceType] = useState([]);
  const dispatch = useDispatch();
  const { allMaintenanceType } = useSelector((state) => state.maintenanceType);
  const table = useRef();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    dispatch(getAllMaintenanceTypes());
  }, []);

  useEffect(() => {
    if (allMaintenanceType) {
      setMaintenanceType(allMaintenanceType);
      setLoading(false);
    }
  }, [allMaintenanceType]);

  const screenColumns = [
    { title: "نوع عنصر الصيانة", data: "name" },
    {
      title: "عمليات",
      data: null,
      render: (data, type, row) => `
        <div class="d-flex gap-3 justify-content-center align-items-center">
          <a href="/editMaintenanceType/${row.id}" class="text-decoration-none">
            <i class="fa-solid fa-pen text-primary"></i>
          </a>
          <button class="delete-btn border-0 bg-transparent" data-id="${row.id}">
            <i class="fa-solid fa-trash text-danger"></i>
          </button>
        </div>
      `,
    },
  ];

  useEffect(() => {
    const handleDelete = (e) => {
      if (e.target.closest(".delete-btn")) {
        const id = e.target.closest(".delete-btn").getAttribute("data-id");
        Swal.fire({
          title: "هل أنت متأكد؟",
          text: "لن تتمكن من التراجع عن هذا الإجراء!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: "نعم، احذفها!",
          cancelButtonText: "إلغاء",
        }).then((result) => {
          if (result.isConfirmed) {
            dispatch(deleteMaintenanceType(id)).then((res) => {
              if (!res.error) {
                Swal.fire("تم الحذف!", "تم حذف نوع الصيانة بنجاح.", "success");
                dispatch(getAllMaintenanceTypes());
              } else {
                Swal.fire("فشل الحذف", res.payload || "حدث خطأ أثناء الحذف", "error");
              }
            });
          }
        });
      }
    };

    const tableElement = document.querySelector(".dataTable");
    tableElement?.addEventListener("click", handleDelete);

    return () => {
      tableElement?.removeEventListener("click", handleDelete);
    };
  }, [maintenanceType]);

  return (
    <>
      <div className="main">
        <div className="container-fluid">
          <div className="row justify-content-between align-items-center mt-3">
            <div className="col-md-4 d-flex justify-content-md-start justify-content-center mb-3">
              <div className="card py-2 px-3">
                <p className="mb-0 primary-100">عدد الأنواع: {maintenanceType?.length}</p>
              </div>
            </div>
            <div className="col-md-4 text-md-end text-center">
              <Link to="/addMaintenanceType" className="btn btn-primary text-white">
                إضافة نوع صيانة
              </Link>
            </div>
          </div>

          <div className="table-responsive" style={{ overflowX: "auto" }}>
            <div>
              <p className="text-center mb-0 fs-5">بحث</p>
            </div>

            {maintenanceType && maintenanceType.length > 0 && !loading && <DataTable data={maintenanceType} columns={screenColumns} className="display table table-striped table-bordered" options={{ responsive: true }} ref={table} />}
          </div>
        </div>
      </div>

      <style>
        {`
          .table-responsive {
            overflow-x: auto;
          }
        `}
      </style>
    </>
  );
}
